/** @jsxImportSource @emotion/react */
import PropTypes from "prop-types";
import {
  twoColumnLayoutCss,
  columnCss,
  columnHeaderCss,
  contentBodyCss,
  analysisItemCss,
} from "./index.css";

// eslint-disable-next-line react/prop-types
function AnalysisItem({ title, value }) {
  return (
    <div css={analysisItemCss}>
      <strong>{title}</strong>
      <p>{value || "N/A"}</p>
    </div>
  );
}
function decodeHtmlEntities(text) {
  if (!text) return "";
  try {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = text;
    return textarea.value;
  } catch (e) {
    console.error("Failed to decode HTML entities", e);
    return text;
  }
}

export default function ModalContent({ rowData }) {
  const emailBody = decodeHtmlEntities(rowData?.body) || "No content found.";
  const insights = rowData?.insights || "N/A";
  const summary = rowData?.summary || "N/A";

  const sellerEmail = rowData?.sellerEmail || "N/A";
  const dateReplied = rowData?.repliedAt || "N/A";
  const campaignName = rowData?.campaignName || "N/A";
  const sentiment = rowData?.sentiment || "N/A";
  const persona = rowData?.prospect_persona || rowData?.persona || "N/A";
  const partnerPersonas = rowData?.partner_persona || "N/A";
  const agency = rowData?.prospect_agency || rowData?.agency || "N/A";
  const subject = rowData?.subject;
  const role = rowData?.prospect_role;
  const partnerName = rowData?.partnerName || rowData?.partner_name || "N/A";

  return (
    <div css={twoColumnLayoutCss}>
      {/* Left Column */}
      <div css={columnCss}>
        <h2 css={columnHeaderCss}>Original Email</h2>
        <div css={contentBodyCss}>{emailBody}</div>
      </div>

      {/* Right Column */}
      <div css={columnCss}>
        <h2 css={columnHeaderCss}>Analysis</h2>
        <div>
          <AnalysisItem title="Insights" value={insights} />
          <AnalysisItem title="Summary" value={summary} />
          <AnalysisItem title="Seller Email" value={sellerEmail} />
          <AnalysisItem title="Date Replied" value={dateReplied} />
          <AnalysisItem title="Phase" value={campaignName} />
          <AnalysisItem title="Sentiment" value={sentiment} />
          <AnalysisItem title="Agency" value={agency} />
          <AnalysisItem title="Prospect Role" value={role} />
          <AnalysisItem title="Prospect Persona" value={persona} />
          <AnalysisItem title="Partner Personas" value={partnerPersonas} />
          <AnalysisItem title="Partner" value={partnerName} />
          <AnalysisItem title="Subject" value={subject} />
        </div>
      </div>
    </div>
  );
}

ModalContent.propTypes = {
  rowData: PropTypes.shape({
    body: PropTypes.string,
    insights: PropTypes.string,
    summary: PropTypes.string,
    sellerEmail: PropTypes.string,
    repliedAt: PropTypes.string,
    sentiment: PropTypes.string,
    campaignName: PropTypes.string,
    agency: PropTypes.string,
    persona: PropTypes.string,
    partner_persona: PropTypes.string,
    prospect_agency: PropTypes.string,
    prospect_persona: PropTypes.string,
    prospect_role: PropTypes.string,
    subject: PropTypes.string,
    partnerName: PropTypes.string,
    partner_name: PropTypes.string,
  }),
};
